import { render } from "./ViewRekomendasiPSB.vue?vue&type=template&id=bdd4ff8e"
import script from "./ViewRekomendasiPSB.vue?vue&type=script&lang=js"
export * from "./ViewRekomendasiPSB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__